import React, { useState, useEffect } from 'react';
import { Box, Tooltip } from '@mui/material';
import { GRID_CHECKBOX_SELECTION_COL_DEF } from '@mui/x-data-grid-pro';
import { Dialog } from '../../components/Dialog';
import { getGrowersAssignable, getGrowersForUser } from '../../lib/api';
import { Table, TableCell } from '../../components/table/Table';
import { useAlerts } from '../../hooks/use-alerts';
import { usePermission } from '../../hooks/use-permission';

export function UserOperationsAssignment(props) {
  const { user, handleClose, handleSaveGrowers } = props;
  const [growers, setGrowers] = useState();
  const [assigned, setAssigned] = useState([]);
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({});
  const { showError } = useAlerts();
  const areCheckboxesSortable = usePermission('ADMIN_QUEUES');

  useEffect(() => {
    Promise.all([
      getGrowersForUser(user.username),
      getGrowersAssignable(user.username),
    ])
      .then(([userGrowers, allGrowers]) => {
        setAssigned(userGrowers.map((g) => g.growerOperationGuid));
        setGrowers(allGrowers);
      })
      .catch(showError);
  }, [user, showError]);

  return (
    <Dialog
      title={`Operations for User: ${user.username}`}
      canSave={Boolean(growers?.length)}
      onCancel={handleClose}
      onSave={handleSave}
    >
      <Box sx={{ height: 'calc(100vh - 250px)' }}>
        <Table
          rows={growers || []}
          columns={buildTableColumns()}
          getRowId={(row) => row.guid}
          checkboxSelection
          rowSelectionModel={assigned}
          onRowSelectionModelChange={setAssigned}
          loading={!growers}
          hideFooter={false}
          initialState={{
            sorting: {
              sortModel: [{ field: 'operationName', sort: 'asc' }],
            },
          }}
          localeText={{
            noRowsLabel: 'No operations are available for assignment',
            footerTotalRows: 'Total Operations:',
            footerRowSelected: (count) => `${count.toLocaleString()} assigned`,
          }}
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityChange={({ field, isVisible }) =>
            setColumnVisibilityModel((prev) => ({
              ...prev,
              [field]: isVisible,
            }))
          }
        />
      </Box>
    </Dialog>
  );

  function handleSave() {
    return handleSaveGrowers(user.username, assigned)
      .then(handleClose)
      .catch(showError);
  }

  function buildTableColumns() {
    const selectionCol = {
      ...GRID_CHECKBOX_SELECTION_COL_DEF,
      sortable: true,
      valueGetter: (params) => assigned.includes(params.id),
    };
    return [
      ...(areCheckboxesSortable ? [selectionCol] : []),
      {
        flex: 1,
        field: 'operationName',
        headerName: 'Operation',
        renderCell: (params) => (
          <TableCell>
            <Tooltip title={params.row.guid}>
              <span>{params.row.operationName}</span>
            </Tooltip>
          </TableCell>
        ),
      },
      {
        flex: 1,
        field: 'organization',
        headerName: 'Organization',
        valueGetter: (params) => params.row.organization?.name,
      },
      {
        flex: 1,
        field: 'primaryAgronomist',
        headerName: 'Primary Agronomist',
      },
      {
        flex: 0.5,
        field: 'region',
        headerName: 'Region',
      },
    ];
  }
}
